import classNames from 'classnames'
import React from 'react'

export const Card: React.FC<{ className?: string; onClick?: () => void }> = props => (
    <div {...props} className={classNames('bg-white rounded-2xl shadow-md', props.className)}>
        {props.children}
    </div>
)
